import React, { FC } from 'react';

import cn from 'classnames';
import type { ImageProps } from 'next/legacy/image';
import Image from 'next/legacy/image';

import styles from './index.module.less';

export type Src = ImageProps['src'];
interface ImgShadowProps {
  src: ImageProps['src'];
  height: number;
  width: number;
  className?: string;
}

export const ImgShadow: FC<ImgShadowProps> = (props) => {
  const { src, height, width, className } = props;
  return (
    <div className={cn(styles.imgContainer, className)}>
      <div className={cn(styles.img, styles.imgFilter)}>
        <Image src={src} width={width} height={height} alt="kikitrade" />
      </div>
      <div className={styles.img}>
        <Image src={src} width={width} height={height} alt="kikitrade" />
      </div>
    </div>
  );
};
